<template>
  <LazyNoticeIndex />
</template>

<script setup lang="ts">
definePageMeta({
  pageTransition: false,
  layoutTransition: true,
  layout: 'center',
  middleware: [
    'naver-ads',
    'kakao-pixel'
  ]
})

const { ogUrl, ogTitle, keyword } = useSeo()

useSeoMeta({
  title: '공지사항',
  description: '유심사 서비스에 대한 공지사항을 제공해요.',
  ogType: 'website',
  ogUrl: () => ogUrl('board/notice'),
  ogTitle: () => ogTitle('공지사항'),
  ogDescription: '유심사 서비스에 대한 공지사항을 제공해요.',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('공지사항'),
  twitterDescription: '유심사 서비스에 대한 공지사항을 제공해요.',
  keywords: keyword('공지사항, eSIM공지사항, 이심공지사항, USIM공지사항, 유심공지사항')
})

</script>
